module.exports = "<igo-import-export></igo-import-export>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/tools/import-export-tool/import-export-tool.component.html
// module id = 1129
// module chunks = 0